module.exports = {"GOOGLE_CLIENT_ID":"517623523027-fm6a1q8k7g7eprpjs3tghq4fljt23v0h.apps.googleusercontent.com"}


//////////////////
// WEBPACK FOOTER
// ./src/utils/clientGoogle.json
// module id = 664
// module chunks = 0